export default {
  // Nav
  'nav.spreadsheet': 'Spreadsheet',
  'nav.categories': 'Categories',
  'nav.guide': 'Guide',
  'nav.faq': 'FAQ',
  'nav.home': 'Home',
  'nav.shopping': 'Shopping Guide',
  'nav.cta': 'Buy It Now',

  // Hero
  'hero.badge': 'Independent Resource · Multilingual Guides · Safety-Focused',
  'hero.h1': 'USFans Spreadsheet — Find, Explore & Organize USFans Information',
  'hero.sub': 'Explore USFans spreadsheet resources, creator guides, reviews, shipping information, coupons, warehouse guides and safety resources — organized in one fast, easy-to-use platform.',
  'hero.ctaPrimary': 'Explore USFans Spreadsheet',
  'hero.ctaSecondary': 'Read the USFans Guide',
  'hero.trust': 'Independent Resource • Updated Content • Multilingual Guides • Safety-Focused',
  'hero.scroll': 'Scroll to explore',

  // Dropdown
  'dropdown.label': 'Browse categories',
  'dropdown.placeholder': 'Select a category…',

  // Categories
  'categories.title': 'Shop by Category',
  'categories.sub': 'Browse popular USFans categories and discover styles, all organized in one place. Every link opens the official store in a new tab.',
  'categories.hint': 'Each category leads to the main USFans store.',
  'categories.view': 'Open category',

  // Feature cards
  'features.title': 'Everything You Need in One Place',
  'features.sub': 'A complete USFans resource hub built around clear, useful information.',
  'features.1.title': 'USFans Spreadsheet',
  'features.1.desc': 'Explore organized USFans spreadsheet resources and guides.',
  'features.2.title': 'USFans Review',
  'features.2.desc': 'Understand features, usability, shipping and important considerations.',
  'features.3.title': 'USFans Shipping Cost',
  'features.3.desc': 'Learn how shipping costs work and what affects the final price.',
  'features.4.title': 'USFans Coupon',
  'features.4.desc': 'Find information about coupons, promotions and discount opportunities.',
  'features.5.title': 'USFans Warehouse',
  'features.5.desc': 'Learn how warehouse storage, inspection and shipping processes work.',
  'features.6.title': 'Is USFans Legit?',
  'features.6.desc': 'Understand legitimacy, safety, privacy and common risks.',

  // Intro / about
  'about.title': 'Looking for a better way to explore USFans information?',
  'about.p1': 'Our USFans Spreadsheet hub brings together useful guides, creator resources, reviews, shipping information, warehouse explanations, discounts, comparisons and safety tips in one organized resource.',
  'about.p2': 'Whether you are researching USFans for the first time or looking for specific information, start with the USFans Spreadsheet hub.',

  // Guide CTA
  'guide.title': 'Read Our USFans Spreadsheet Guide',
  'guide.sub': 'A complete, original guide covering what a USFans spreadsheet is, how it works, how to search creators and how to stay safe.',
  'guide.cta': 'Read the Full Guide',
  'guide.meta': 'Updated · Original content · Safety-focused',

  // Guides
  'guides.title': 'Explore All USFans Guides',
  'guides.sub': 'A complete library of in-depth guides covering the spreadsheet, creators, reviews, shipping, coupons, warehouse and safety.',

  // FAQ
  'faq.title': 'Frequently Asked Questions',
  'faq.sub': 'Quick answers about the USFans Spreadsheet resource.',
  'faq.1.q': 'What is a USFans Spreadsheet?',
  'faq.1.a': 'It is an organized resource that collects USFans-related information — creator listings, categories, guides and links — in one easy-to-browse place.',
  'faq.2.q': 'Is this website affiliated with USFans?',
  'faq.2.a': 'No. USFansLink.rest is an independent informational website and is not necessarily affiliated with, endorsed by, or operated by USFans.',
  'faq.3.q': 'How do I browse USFans categories?',
  'faq.3.a': 'Use the category dropdown or the category buttons below. Each one opens the matching category in the main USFans store.',
  'faq.4.q': 'Are the guides free to read?',
  'faq.4.a': 'Yes, all guides and articles on this site are free and written for informational purposes.',
  'faq.5.q': 'Do you verify the information?',
  'faq.5.a': 'We aim to keep content useful and accurate, but third-party information can change. Always verify current details independently.',

  // Main CTA
  'cta.title': 'Ready to Explore the Full USFans Store?',
  'cta.sub': 'Browse the complete collection, discover new categories and shop directly on the main USFans website.',
  'cta.primary': 'USFans Spreadsheet',
  'cta.secondary': 'Buy It Now',

  // Footer
  'footer.tagline': 'An independent, multilingual resource for exploring USFans information.',
  'footer.disclaimer': 'USFansLink.rest is an independent informational website and is not necessarily affiliated with, endorsed by, or operated by USFans. Third-party information may change; please verify details independently.',
  'footer.links': 'Quick Links',
  'footer.copyright': '© 2026 USFansLink.rest. All rights reserved.',

  // Article
  'article.breadcrumb': 'Home',
  'article.category': 'Guide',
  'article.shortTitle': 'USFans Spreadsheet Guide',
  'article.readTime': '8 min read',
  'article.updated': 'Updated',
  'article.toc': 'Table of Contents',
  'article.related': 'Related Guides',

  'article.h1': 'USFans Spreadsheet: Complete Creator, Search & Resource Guide',
  'article.lead': 'Learn what a USFans spreadsheet is, how it works, how to search creators, organize information and stay safe — in one complete guide.',

  'article.s1.title': 'What Is a USFans Spreadsheet?',
  'article.s1.p1': 'A USFans spreadsheet is an organized, shared resource that collects information related to USFans in a structured, easy-to-browse format. It typically brings together creator listings, categories, profiles, status details, update timestamps and helpful resource links in a single table-like view.',
  'article.s1.p2': 'For many people, the spreadsheet acts as a central starting point. Instead of searching through many separate pages, users can scan one organized layout to find what they are looking for quickly. It is especially useful for discovering new creators and exploring categories they might not have considered.',

  'article.s2.title': 'How the Spreadsheet Works',
  'article.s2.p1': 'Most USFans spreadsheets follow a simple column-based structure. A typical layout includes columns for the creator name, category, profile link, current status and the date the entry was last updated. This structure makes it easy to sort, filter and compare information at a glance.',
  'article.s2.p2': 'Some spreadsheets are maintained manually and updated on a schedule, while others are refreshed more frequently. Because the underlying data can change, it is always a good idea to check the source and verify important details before relying on them.',

  'article.s3.title': 'How to Search Creators',
  'article.s3.p1': 'Searching a USFans spreadsheet usually starts with the categories or filters. If you are looking for a specific creator, use the search or filter function to narrow the results by name. If you are exploring, browse by category first and then review individual entries.',
  'article.s3.p2': 'A good approach is to start broad and then narrow down. Begin with a category that interests you, then look at status and update information to prioritize active and recently updated entries.',

  'article.s4.title': 'Common Categories',
  'article.s4.p1': 'USFans resources are often grouped into categories to make browsing easier. These commonly include clothing, footwear, accessories, bags, belts, fragrances and various other items. Grouping entries by category helps users compare similar options side by side.',
  'article.s4.p2': 'On this site, the category dropdown and the category buttons below each link to the corresponding section of the main store, so you can go straight from research to browsing real products.',

  'article.s5.title': 'Spreadsheet vs Directory vs Manual Search',
  'article.s5.p1': 'It helps to understand how a spreadsheet compares with other ways of finding information. The table below summarizes the main differences.',
  'article.table.c1': 'Aspect',
  'article.table.c2': 'Spreadsheet',
  'article.table.c3': 'Directory',
  'article.table.c4': 'Manual Search',
  'article.table.r1c1': 'Format',
  'article.table.r1c2': 'Structured rows & columns',
  'article.table.r1c3': 'Categorized listing pages',
  'article.table.r1c4': 'One search at a time',
  'article.table.r2c1': 'Best for',
  'article.table.r2c2': 'Scanning & comparing',
  'article.table.r2c3': 'Browsing by topic',
  'article.table.r2c4': 'Finding a specific item',
  'article.table.r3c1': 'Freshness',
  'article.table.r3c2': 'Depends on updates',
  'article.table.r3c3': 'Depends on maintenance',
  'article.table.r3c4': 'Always live',
  'article.table.r4c1': 'Learning curve',
  'article.table.r4c2': 'Low',
  'article.table.r4c3': 'Very low',
  'article.table.r4c4': 'None',

  'article.s6.title': 'Data Verification & Safety',
  'article.s6.p1': 'Because USFans spreadsheets and directories are often community-maintained, the information may not always be complete or fully up to date. Always verify important details such as links, prices and availability directly on the official store before making decisions.',
  'article.s6.p2': 'Stay cautious with any link that asks for personal information or payment outside the official website. Stick to known, trusted links and never share your passwords or account details with anyone.',

  'article.s7.title': 'Privacy Considerations',
  'article.s7.p1': 'When browsing any third-party resource, be mindful of the information you share. Avoid entering sensitive personal data on unfamiliar pages and use the official site for any account or purchase activity.',
  'article.s7.p2': 'This independent resource does not ask for your personal information to browse. If a page requests details that seem unnecessary, it is a good idea to close it and return to the official source.',

  'article.conclusion.title': 'Final Thoughts',
  'article.conclusion.p1': 'A USFans spreadsheet is a convenient way to explore creators, categories and resources in one place. It works best when paired with independent verification and common-sense safety habits.',
  'article.conclusion.p2': 'Ready to browse real products? Use the category dropdown on the homepage, or explore the full USFans store directly.',

  'article.cta': 'Explore the Full Resource',
  'article.backHome': 'Back to Homepage',

  // Category names
  'cat.shoes': 'Shoes',
  'cat.hoodies': 'Hoodies / Sweaters',
  'cat.tshirts': 'T-Shirts',
  'cat.jackets': 'Jackets',
  'cat.pants': 'Pants / Shorts',
  'cat.headwear': 'Headwear',
  'cat.sets': 'Sets',
  'cat.underwear': 'Underwear / Underpants',
  'cat.jersey': 'Jersey',
  'cat.accessories': 'Accessories',
  'cat.bags': 'Bags',
  'cat.belts': 'Belts',
  'cat.perfumes': 'Perfumes',
  'cat.other': 'Other Stuff',
};